<template>
  <div id="poster" class="poster">
    <el-dialog
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="400px"
      :close-on-click-modal="true"
      :append-to-body="true"
      :class="['posterDia', loading && 'loading']"
      :destroy-on-close="true"
    >
      <PosterCont ref="posterCont" :qrObj="qrObj" :block="block"></PosterCont>
      <div class="downloadPos">
        <div @click="downloadPoster()">{{ language.downloadPosterImages }}</div>
      </div>
      <!-- 高清海报 -->
      <PosterCont id="posterOrigin" v-show="false" :qrObj="qrObj" :isHighReso="true"></PosterCont>
    </el-dialog>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import PosterCont from './posterCont'
export default {
  name: 'poster',
  data() {
    return {
      dialogVisible: false,
      lock: true,
      block: false,
      loading: false //用于下载海报中屏蔽页面滚动条
    }
  },
  props: {
    qrObj: {
      type: Object,
      default: function() {
        return {}
      }
    },
    currentLang: {
      default: 0
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    language() {
      return this.$store.state.config.languageOptions[this.currentLang]
    }
  },
  methods: {
    downImg(src) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = src
      a.download = '海报下载'
      a.click()
      a.style.display = 'none'
      document.body.removeChild(a)
    },
    downloadPoster() {
      this.loading = true
      const curEl = document.getElementById('posterOrigin')
      curEl.style.display = 'block'
      new html2canvas(curEl, {
        backgroundColor: 'transparent',
        useCORS: true
      }).then((canvas) => {
        // canvas为转换后的Canvas对象
        const oImg = new Image()
        oImg.src = canvas.toDataURL('image/png', 1.0) // 导出图片
        document.body.appendChild(oImg) // 将生成的图片添加到body
        this.downImg(oImg.src)
        oImg.style.display = 'none'
        curEl.style.display = 'none'
        this.loading = false
      })
    }
  },
  components: {
    PosterCont
  }
}
</script>
<style lang="scss" scoped>
.posterDia {
  /deep/.el-dialog {
    height: 650px;
    margin-top: 5vh !important;
    .el-dialog__body {
      padding: 0;
      height: 100%;
    }
    .el-dialog__header {
      padding: 0;
      height: 0;
      .el-dialog__headerbtn {
        top: 9px;
        right: 9px;
        .el-dialog__close {
          color: #fff;
        }
      }
    }
    .posterBg {
      height: 600px;
      margin: 0 auto;
      .posterInner {
        width: 335px;
        height: 600px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;
        .title {
          width: 295px;
          max-height: 43px;
          font-size: 18px;
          font-weight: 500;
          color: #fff;
          line-height: 23px;
          text-align: center;
          margin: 0 auto;
          position: absolute;
          top: 43px;
        }
        .bookImg {
          width: 335px;
          position: relative;
          display: flex;
          justify-content: center;
          .cover {
            max-width: 256px;
            max-height: 360px;
            position: relative;
            z-index: 3;
          }
          .bookcase {
            position: absolute;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 2;
            width: 335px !important;
          }
        }
        .codeFooter {
          width: 256px;
          font-size: 14px;
          height: 80px;
          position: absolute;
          margin: 0 auto;
          bottom: 13px;
          span {
            display: inline-block;
            height: 80px;
            line-height: 80px;
          }
          p {
            width: 150px;
          }
        }
      }
    }
  }
  .downloadPos {
    height: 50px;
    background: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: fit-content;
      padding: 0 10px;
      height: 36px;
      background: #df5813;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
  }
  &.loading {
    overflow: hidden;
  }
}
</style>
